'use client';
import React from 'react';
import { Typography, Box, Card, CardContent, CardActions, Button } from '@mui/material';
import { File, EntityItem } from '@peerless/data-access/strapi';
import { formatMediaUrl } from '../utils';

interface IconCardProps {
  image?: EntityItem<File>;
  title: string;
  description: string;
  linktext: string;
  url: string;
}

export const IconCard: React.FC<IconCardProps> = ({ image, title, description, linktext, url }) => {
  return (
    <Card variant="cardBorder">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {image?.data?.attributes && (
          <Box
            sx={{ height: '6rem', mb: '1rem' }}
            component={'img'}
            src={formatMediaUrl(image.data.attributes)}
          />
        )}

        <Typography variant="h3" component="h3" textAlign="center">
          {title}
        </Typography>
        <Typography textAlign="center">{description}</Typography>
      </CardContent>
      {url && (
        <CardActions sx={{ justifyContent: 'center' }}>
          <Button fullWidth variant="outlined" href={url}>
            {linktext}
          </Button>
        </CardActions>
      )}
    </Card>
  );
};
